import { UserInfo } from "@/components/User/UserInfo";

export const HeaderDrawerItems = () => {
	
	return <>
		<UserInfo />
	</>
}